import { download } from '../actions/actionTypes';
export const initialState = {};
export default function (state = initialState, action) {
    switch (action.type) {
        case download.DOWNLOADED:
            const downloadedPayload = action.payload;
            const newState = { ...state };
            delete newState[downloadedPayload.uriKey];
            return newState;
        case download.DOWNLOADING:
            const downloadingPayload = action.payload;
            return { ...state, [downloadingPayload.uriKey]: downloadingPayload.progress };
        default:
            return state;
    }
}
